import React from 'react'

const SearchFooter = (): React.ReactElement => <div>
  <h4> Vous voulez vous reconvertir vers ce métier ? 👉 Contactez Transitions Pro pour faire financer votre formation <a href="https://www.transitionspro-ara.fr/prenons-contact"> ici </a>. </h4>
</div>

export default SearchFooter
